module.exports = __webpack_public_path__ + "media/37.e336cbb7.mp3";